<template>
  <button class="button-clear" tabindex="-1" type="button">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM6.0689 5.18599C5.82482 4.94191 5.42909 4.94191 5.18501 5.18599C4.94093 5.43006 4.94093 5.82579 5.18501 6.06987L7.11757 8.00244L5.18501 9.93501C4.94093 10.1791 4.94093 10.5748 5.18501 10.8189C5.42909 11.063 5.82482 11.063 6.0689 10.8189L8.00146 8.88633L9.93402 10.8189C10.1781 11.063 10.5738 11.063 10.8179 10.8189C11.062 10.5748 11.062 10.1791 10.8179 9.93501L8.88534 8.00244L10.8179 6.06987C11.062 5.82579 11.062 5.43006 10.8179 5.18599C10.5738 4.94191 10.1781 4.94191 9.93402 5.18599L8.00146 7.11856L6.0689 5.18599Z"
        fill="#B4B7BF"
        style="fill: #b4b7bf; fill: color(display-p3 0.7059 0.7181 0.749); fill-opacity: 1"
      />
    </svg>
  </button>
</template>

<style scoped lang="stylus">
.button-clear
  height 100%
  aspect-ratio 1
  outline none
  text-decoration none
  box-shadow none
  display flex
  cursor pointer
  align-items center
  transition-duration .2s
  text-align center
  justify-content center
  color var(--text-primary)
  border-radius var(--rounding100)
  background-color inherit
  padding 4px

  &:hover
    background-color var(--button-tertiary-neutral-onprimary-hovered)
</style>
